import React from 'react';
import './travel-protection.css';

class TravelProtection extends React.Component {
    constructor(props) {
        super(props);
        this.booking = this.props.booking;
    }

    render = () => {
        return (
            <div className="rea-travelProtection">
                <div className="rea-block-row">
                    <div className="rea-block-12">
                        <div class="rea-block-row">
                            <div class="rea-block-3 rea-padding-0 rea-protectionTitle">
                                <div class="rea-protectionTitleContainer">
                                    <i className="fa fa-shield"></i>
                                    <div className="rea-protectionTitleText">Travel<br/> Insurance</div>
                                </div>
                            </div>
                            <div className="rea-block-9 rea-padding-0 rea-protectionText">
                                <div class="rea-protectionTextContainer">
                                    <div>{this.booking.insuranceParagraph}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default TravelProtection;
